import { getUrlParameter } from './shared/utils';
import { ShowMyCartSummaryAsync } from './aka.js';
import {
  Window,
  FunctionHandler,
  FunctionCallback,
  JsonData,
} from './shared/akatypes';

declare const window: Window;
const jQuery = window.jQuery;

export async function mainfinal() {
  // const id = getUrlParameter('id').toString();
  console.log('main final '); // + id);
  await ShowMyCartSummaryAsync();
  finalBindHandlers();
}

function finalParam2Json() {
  const code = getUrlParameter('code');
  const message = getUrlParameter('message');
  const transactionId = getUrlParameter('transactionId');
  console.log('final url data' + code + message + transactionId);
  const ret: any = {};
  ret.code = code;
  ret.message = message;
  ret.transactionId = transactionId;
  return ret;
}
// https://mrsio2.ctk.cz/?code=6&message=platba+zam%c3%adtnuta&transactionId=12345
// http://localhost/ctk24/final.php?code=3&message=platba+zru%c5%a1ena&transactionId=12345
// spravna testovaci karta https://mrsio2.ctk.cz/?code=7&message=%c4%8dek%c3%a1n%c3%ad+na+z%c3%ba%c4%8dtov%c3%a1n%c3%ad&transactionId=12345
// zpet z platebni brany code=0&message=platba+převodem&transactionId=12345

function finalBindHandlers() {
  console.log('finalBindHandlers');
  const params = finalParam2Json();
  if (
    params.code === '0' ||
    params.code === '7' ||
    params.code === '4' ||
    params.code === '8'
  ) {
    if (params.message === 'platba+převodem') {
      jQuery('#finalmessage').html(
        'Děkujeme, v e-mailu naleznete další informace.',
      );
    }
    jQuery('#displayok').show();
  } else {
    jQuery('#errormessage').html(params.message);
    jQuery('#displaynotok').show();
  }
  jQuery('#finalback').on('click', (event: Event) => {
    window.location.assign('index.php');
    event.preventDefault();
    return false;
  });
}
